import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import OrbitMarkReply from '../../components/OrbitMarkReply';
import { TOrbit } from '../../i18n/TModules';
import { rsColor } from '../../support/response/responseScale';
import { OrbitActionStep } from '../types';

// 6567:2202: the 14 x 15 mark, then Inter Semi Bold 12 in white, 12 apart.
const Line = styled.p<{ $compact: boolean }>`
  display: flex;
  align-items: center;
  margin: ${({ $compact }) => ($compact ? '10px 0 0' : '0')};
  color: ${({ $compact }) => ($compact ? rsColor.secondary : rsColor.white)};
  font-size: 12px;
  font-weight: 600;
  line-height: 15.2px;

  > * + * {
    margin-left: ${({ $compact }) => ($compact ? 6 : 12)}px;
  }
`;

const Mark = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  width: 14px;
  height: 15px;
`;

interface IL4StatusLineProps {
  step: OrbitActionStep;
  /** Inside a card, under its buttons: spinner and copy only, no mark. */
  compact?: boolean;
}

/** The confirming turn while the job runs; the copy is the client's, the server sends none. */
const L4StatusLine: React.FC<IL4StatusLineProps> = ({ step, compact = false }) => {
  const { t } = useMultiLanguageTranslation();
  const { name, id } = step.target;
  const copy = t(`${TOrbit}.layer4.working.${step.type}`, {
    name,
    id,
    defaultValue: t(`${TOrbit}.layer4.working.fallback`, { name })
  });

  return (
    <Line $compact={compact} role="status" data-testid="orbit-l4-working">
      {compact ? null : (
        <Mark aria-hidden="true">
          <OrbitMarkReply />
        </Mark>
      )}
      <LoadingOutlined aria-hidden="true" />
      <span>{copy}</span>
    </Line>
  );
};

export default L4StatusLine;
